import React from "react";
import { styled } from '@mui/material/styles';
import PropTypes from "prop-types";
import { Box, Typography, useTheme } from "@mui/material/";
import Rating from '@mui/material/Rating';
const PREFIX = 'Ratings';

const classes = {
  rating: `${PREFIX}-rating`
};

const StyledBox = styled(Box)((
  {
    theme
  }
) => ({
  [`& .${classes.rating}`]: {
    color: `${theme.palette.primary.light} !important`,
    fontSize: "1rem",
  }
}));

const Ratings = ({
  data,
  hideOpenNow,
  hideNumber,
  textColor,
  variant,
  ...props
}) => {
  const theme = useTheme();

  return (
    <StyledBox display="flex" justifyContent="space-between" {...props}>
      {data.rating && (
        <Box display="flex" alignItems="center">
          {!hideNumber && (
            <Typography
              variant={variant}
              component="span"
              style={{ paddingRight: "5px", paddingTop: "2px" }}
              color={textColor}
            >
              <b>{data.rating}</b>
            </Typography>
          )}
          <Rating
            value={data.rating}
            size="small"
            className={classes.rating}
            readOnly
          />
        </Box>
      )}
      {!hideOpenNow && data.opening_hours?.isOpen() && (
        <Typography
          variant={variant}
          component="span"
          align="right"
          style={{
            color: theme.palette.success.main,
            fontWeight: 500,
          }}
        >
          Open Now
        </Typography>
      )}
    </StyledBox>
  );
};

Ratings.defaultProps = {
  textColor: "textSecondary",
  variant: "h5",
};

Ratings.propTypes = {
  data: PropTypes.object,
  hideOpenNow: PropTypes.bool,
  hideNumber: PropTypes.bool,
  props: PropTypes.object,
  textColor: PropTypes.string,
  variant: PropTypes.string,
};

export default Ratings;
